import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {
  Dropdown,
  DropdownMenuHeader,
  DropdownMenuItem,
  DropdownMenuDivider
} from '@bibliocommons/base-dropdown';
import { fixedEncodeURIComponent } from '@bibliocommons/utils-browser';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import ExternalSearchLink from '../ExternalSearchLink';

import './DidNotFindDropdown.scss';

function injectQueryIntoUrl(query, url) {
  return (query && url) ? url.replace(/{query}/gi, fixedEncodeURIComponent(query)) : url;
}

export default class DidNotFindDropdown extends BcReactComponent {
  renderResourceLink(linkText, url) {
    return (
      <a
        className="did-not-find-link"
        href={injectQueryIntoUrl(this.props.query, url)}
        rel="noopener noreferrer"
        target="_blank">
        <span aria-hidden>
          { linkText }
        </span>
        <ScreenReaderMessage>
          <FormattedMessage id="ada_opens_a_new_tab" values={{ linkText }} />
        </ScreenReaderMessage>
      </a>
    );
  }

  renderExternalSearchLink() {
    const { query, searchType } = this.props;

    return (
      <DropdownMenuItem key="external-link-item">
        <ExternalSearchLink query={query} searchType={searchType} />
      </DropdownMenuItem>
    );
  }

  renderResourceLinksMenu() {
    const { showExternalSearchLink, searchType } = this.props;

    const resourceLinkMenuHeader = (
      <DropdownMenuHeader key="resource-link-menu-header">
        <FormattedMessage id="more_resources" />
      </DropdownMenuHeader>
    );

    const resourceLinkMenuItems = this.props.didNotFindOptions.get('didNotFindResources').map((resource) => (
      <DropdownMenuItem
        key={`did-not-find-link-${resource.get('resourceName').toLowerCase()}`}>
        {this.renderResourceLink(resource.get('resourceName'), resource.get('resourceLink'))}
      </DropdownMenuItem>
    ));

    const menuDivider = (
      <DropdownMenuDivider key="did-not-find-resource-links-divider" />
    );

    const externalSearchLink = (showExternalSearchLink && searchType !== 'bl') ? [this.renderExternalSearchLink(), menuDivider] : null;

    return [
      externalSearchLink,
      resourceLinkMenuHeader,
      resourceLinkMenuItems
    ];
  }

  render() {
    return (
      <div className="cp-did-not-find-dropdown">
        <Dropdown
          selected={<FormattedMessage id="other_resources" />}
          className="">
          { this.renderResourceLinksMenu() }
        </Dropdown>
      </div>
    );
  }
}

DidNotFindDropdown.propTypes = {
  query: PropTypes.string,
  searchType: PropTypes.string,
  didNotFindOptions: ImmutablePropTypes.map,
  showExternalSearchLink: React.PropTypes.bool

};



// WEBPACK FOOTER //
// ./app/components/search/DidNotFindDropdown/DidNotFindDropdown.jsx